module.exports = __webpack_public_path__ + "static/media/82.2c87cba.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/82.wav
// module id = SO5J
// module chunks = 0